export default __webpack_public_path__ + "static/media/fd.07829539.mp3";